import { useEffect } from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import firebase from "firebase/app";
import { getAuthState, getAppState } from "../redux/selectors";
import {
	Login,
	LoginWithPhone,
	ForgetPassword,
	Register,
	Dashboard,
	Branches,
	ClubManagement,
	UserManagement,
	Profile,
	Club,
	Branch,
	EmailVerify,
	BookingCalendar,
	BookingOptions,
	UserDashboard,
	BookingHistory,
	ShareBranches,
	ManageDashboard,
	ClubsForUser,
	MarketManagement,
	Shop,
	ProductDetail,
	CategoryProduct,
	ClubShop,
	CommunityShop,
	ClubDetailShop,
	ClubDashboard,
	Orders,
	Import,
	ComingSoon,
	Transactions,
	UserTable
} from "../pages";
import { MainContainer } from "../components/MainContainer";
import { PrivateRoute } from "./PrivateRoute";
import { UPDATE_LOGIN_USER } from "../redux/constants";

export function AppRouter() {
	const { currentUser, authType, emailVerified } = useSelector(getAuthState);
	const { locale } = useSelector(getAppState);
	const { i18n } = useTranslation();
	const dispatch = useDispatch();

	useEffect(() => {
		i18n.changeLanguage(locale);
	}, [locale])

	useEffect(() => {
		if (currentUser) {
			firebase.firestore().collection('users').doc(currentUser.id)
				.onSnapshot(documentSnapshot => {
					const userData = documentSnapshot.data();
					dispatch({
						type: UPDATE_LOGIN_USER,
						payload: { userInfo: userData }
					})
				})
		}
	}, [])

	// For Coming soon page
	// return (
	// 	<Switch>
	// 		<Route path="*" component={ComingSoon} />
	// 	</Switch>
	// );

	if (currentUser && authType === "phone" || (authType === "email" && emailVerified) || (currentUser?.role === "admin" || currentUser?.role === "manager")) {
		if (currentUser?.role === "admin" || currentUser?.role === "manager")
			return (
				<Switch>
					<MainContainer>
						<Route path="/" exact render={() => <Redirect to={{ pathname: "/dashboard" }} />} />
						<Route path="/login" exact render={() => <Redirect to={{ pathname: "/dashboard" }} />} />
						<PrivateRoute path="/dashboard" exact component={currentUser?.role === "admin" ? Dashboard : ManageDashboard} />
						<PrivateRoute path="/clubs" exact component={ClubManagement} />
						<PrivateRoute path="/users" exact component={currentUser?.role === "admin" ? UserManagement : UserTable} />
						<PrivateRoute path="/market" exact component={MarketManagement} />
						<PrivateRoute path="/clubs/:clubId" exact component={Club} />
						<PrivateRoute path="/orders/:orderID" exact component={Orders} />
						<PrivateRoute path="/users/:userId/branches" exact component={Branches} />
						<PrivateRoute path="/booking/:branchId/calendar" exact component={BookingCalendar} />
						<PrivateRoute path="/booking/:branchId/book" exact component={BookingOptions} />
						<PrivateRoute path="/booking/import" exact component={Import} />
						<PrivateRoute path="/clubs/:clubId/bookings" component={BookingHistory} />
						<PrivateRoute path="/clubs/:clubId/dashboard" component={ClubDashboard} />
						<PrivateRoute path="/clubs/:clubId/branch/:branchId" exact component={Branch} />
						<PrivateRoute path="/share/:clubId" exact component={Club} />
						<PrivateRoute path="/share/:clubId/:branchId/calendar" exact component={Branch} />
						<PrivateRoute path="/transactions" exact component={Transactions} />
						<PrivateRoute path="/profile" exact component={Profile} />
						<Route path="/shop/product/:productId" exact component={ProductDetail} />
						<Route path="/shop/category/:categoryId" exact component={CategoryProduct} />
						<Route path="/shop/club" exact component={ClubShop} />
						<Route path="/shop/club/:clubId" exact component={ClubDetailShop} />
						<Route path="/shop/community" exact component={CommunityShop} />
					</MainContainer>
				</Switch>
			)
		return (
			<Switch>
				<MainContainer>
					<Route path="/login" exact render={() => <Redirect to={{ pathname: "/booking" }} />} />
					<Route path="/" exact render={() => <Redirect to={{ pathname: "/booking" }} />} />
					<PrivateRoute path="/booking" exact component={ClubsForUser} />
					<PrivateRoute path="/dashboard" exact component={UserDashboard} />
					<PrivateRoute path="/booking/branches/:clubId" exact component={Branches} />
					<PrivateRoute path="/booking/:branchId/calendar" exact component={BookingCalendar} />
					<PrivateRoute path="/booking/:branchId/book" exact component={BookingOptions} />
					<PrivateRoute path="/share/:clubId" exact component={Branches} />
					<PrivateRoute path="/market" exact component={MarketManagement} />
					<PrivateRoute path="/profile" exact component={Profile} />

					<Route path="/shop/product/:productId" exact component={ProductDetail} />
					<Route path="/shop/category/:categoryId" exact component={CategoryProduct} />
					<Route path="/shop/club" exact component={ClubShop} />
					<Route path="/shop/club/:clubId" exact component={ClubDetailShop} />
					<Route path="/shop/community" exact component={CommunityShop} />
				</MainContainer>


			</Switch>
		)
	}
	return (
		<Switch>
			<Route path="/" exact component={Login} />
			<Route path="/login" exact component={Login} />
			<Route path="/shop" exact component={Shop} />
			<Route path="/shop/product/:productId" exact component={ProductDetail} />
			<Route path="/shop/category/:categoryId" exact component={CategoryProduct} />
			<Route path="/shop/club" exact component={ClubShop} />
			<Route path="/shop/club/:clubId" exact component={ClubDetailShop} />
			<Route path="/shop/community" exact component={CommunityShop} />
			<Route path="/register" exact component={Register} />
			<Route path="/login_with_phone" exact component={LoginWithPhone} />
			<Route path="/forget_password" exact component={ForgetPassword} />
			<Route path="/email_verify" exact component={EmailVerify} />
			<Route path="/share/:clubId" exact component={ShareBranches} />
			<Route path="/share/:clubId/:branchId/calendar" exact component={BookingCalendar} />
			<Route path="/share/:clubId/:branchId/booking" exact component={BookingOptions} />
			<Route path="*" component={Login} />
		</Switch>
	)

}
